import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';

const NoContentMessage = ({ message }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center bg-bg-light rounded-lg shadow-md border border-border-subtle">
      <FontAwesomeIcon icon={faBoxOpen} className="text-accent-red text-5xl mb-4" />
      <p className="text-xl font-semibold text-text-white mb-2">
        {message || "No content found."}
      </p>
      <p className="text-text-gray">
        It looks like there's nothing here yet. Please check back later!
      </p>
    </div>
  );
};

export default NoContentMessage;